<ng-container *ngIf="item && isQuantity">
  <lhc-input [item]="item"></lhc-input>
  <lhc-unit [item]="item"></lhc-unit>
</ng-container>
